import ApiHelper from "../../helper/ApiHelper";

class FeedbackApi {

    /**
     * Submit feedback (bug report or feature request)
     * @param {Object} feedbackData - The feedback data
     * @param {string} feedbackData.type - 'bug' or 'feature'
     * @param {string} feedbackData.title - Issue title
     * @param {string} feedbackData.description - Issue description
     * @param {Object} feedbackData.context - Submission context
     * @param {string} token - Auth token
     * @returns {Promise} - API response
     */
    submitFeedback(feedbackData, token) {
        return ApiHelper.post('/admin/api/v1/feedback', feedbackData, {}, { token: token }, false);
    }
}

const serviceInstance = new FeedbackApi();
Object.freeze(serviceInstance);
export default serviceInstance;
